import { Theme } from "@mui/material";

export const getTabTitleStyles = (
  theme: Theme,
  isActiveTab: boolean,
  isFirstTab: boolean
) => ({
  py: { xs: 1, md: 2, xl: 4 },
  borderLeft: isActiveTab
    ? `4px solid ${theme.palette.primary.main}`
    : " `4px solid transparent",
  pl: 2,
  backgroundImage: {
    xs: isActiveTab
      ? `linear-gradient(to right, rgba(255, 107, 0, 0.08) 1%, rgba(255, 107, 0, 0.05) 3%, rgba(255, 107, 0, 0.01) 5%, rgba(255, 107, 0, 0) 10%, white)`
      : "none",
    md: `none`,
  },
  mb: { xs: isFirstTab ? 0.5 : 0, md: isFirstTab ? 0.25 : 0 },
});

export const imageWrapperStyles = {
  width: "100%",
  height: "auto",
  maxWidth: { xs: 343, md: 750 },
  mx: "auto",
  position: "relative",
};

export const imageStyles = {
  width: "100%",
  height: "auto",
  objectFit: "contain",
};

export const iconButtonStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%,-50%)",
  padding: 0,
};

export const playIconStyles = {
  background: "white",
  p: 2,
  width: 24,
  height: 24,
};
